import "./bannerClientes.css";
import Caminata from "../img/Caminata.jpg";
import Escalada from "../img/Escalada.jpg";
import Cueva from "../img/Cueva.jpg";
import Cuarta from "../img/Cuarta.jpg";
import { FormattedMessage } from "react-intl";

function BannerClientes() {
    const fotos_clientes = [
        { url: Caminata, alt: "Caminata" },
        { url: Escalada, alt: "Escalada" },
        { url: Cueva, alt: "Cueva" },
        { url: Cuarta, alt: "Cuarta" },
    ];

    // Duplicate the first 3 images to create a seamless loop (Bucle sin interrumpir) 
    const carouselImages = [...fotos_clientes.slice(0), ...fotos_clientes.slice(0)];
    
    return (
        <section className="banner-clientes">
            <div className="titulo-clientes">
                <p>
                    <FormattedMessage
                        id="inicio.titulo_clientes"
                        defaultMessage="Nuestros Clientes"
                    />
                </p>
            </div>
            <div className="banner">
                <div className="carousel">
                    <div className="carousel-container">
                        {carouselImages.map((foto, index) => (
                            <div key={index} className="card-imagenes">
                                <img src={foto.url} alt={foto.alt} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export { BannerClientes }


